<template>
  <div class="container has-text-centered">
    <div class="column is-half is-offset-one-quarter">
      <p class="back">
         <router-link to="/"> Ir a la inscripción </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>

.back {
  color: var(--border);
  font-size: 35px;
}
</style>